<template>
  <div :class="$style['pt-roles-form']">
      <pt-page-title title="角色权限"></pt-page-title>
      <pt-sub-title title="角色信息"></pt-sub-title>
      <table :class="$style['roles-basic-message-table']">
       <pt-form-list-item label="角色名：" required   @widthItem="widthItem" :widthMax="width_max">
           <wt-input v-model="formValue.displayName" :disabled="disabledEdit"  data-vv-as="角色名"  name="displayName"  v-validate="'required'"></wt-input>
       </pt-form-list-item>
      </table>
      <pt-sub-title title="角色权限"></pt-sub-title>
      <table>
        <pt-form-list-item label="包含角色：">
           <wt-selector :class="$style['org-select']" :options="rolesList" :props="roleProp" v-model="formValue.compositeRoles" multiple></wt-selector>
        </pt-form-list-item>
          <pt-form-list-item label="权限设置：" required>
            <wt-checkbox :disabled="disabledEdit" v-model="formValue.permissions" :checkList="permissionsList" valueName="id" labelName="displayName"
            :class="$style['premission-checkbox']"   data-vv-as="权限设置"  name="permissions"  v-validate="'required'"></wt-checkbox>
          </pt-form-list-item>
          <pt-form-list-item label="菜单设置："  @widthItem="widthItem" :widthMax="width_max" required>
              <div  v-for="(item,index) in menuList"  :key="index" :class="$style['menu-permissions']">
              <wt-checkbox :disabled="disabledEdit" isShowAll isParentSelected :allLable="item.displayName" :allValue="item.id" isOutParentCheck :checkList="item.children"
              valueName="id" labelName="displayName" v-model="item.checkbox">
              </wt-checkbox>
              </div>
          </pt-form-list-item>
      </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { maxValueMethod } from 'utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-roles-form'

export default {
  name: 'pt-roles-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 控制页面不可编辑
    disabledEdit () {
      return false
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    permissionsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    rolesDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formValue: {
        userMenus: []
      },
      menuList: [],
      width_max: '',
      widthArr: [],
      roleProp: {
        value: 'id',
        label: 'displayName'
      }
    }
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
      },
      immediate: true
    },
    menuList: {
      handler: function (val) {
        val.forEach(item => {
          if (item.checkbox) {
            this.formValue.userMenus = this.concatArray(this.formValue.userMenus, item.checkbox)
          }
        })
      },
      deep: true
    },
    rolesDetail: {
      handler: function (val) {
        this.formValue = val
        val.userMenus.forEach(etem => {
          this.menuList.forEach(item => {
            if (item.id === etem) {
              item.checkbox = []
              item.checkbox.push(item.id)
              item.children.forEach(atem => {
                val.userMenus.forEach(ftem => {
                  if (atem.id === ftem) {
                    item.checkbox.push(atem.id)
                  }
                })
              })
            }
          })
        })
      }
    }
  },
  destroyed () {
    this.menuList.forEach(item => {
      item.checkbox = null
    })
  },
  methods: {
    concatArray () {
      let newArr = Array.prototype.concat.apply([], arguments)// 没有去重复的新数组
      return Array.from(new Set(newArr))
    },
    widthItem (val) {
      this.widthArr.push(val)
      this.width_max = maxValueMethod(this.widthArr)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-roles-form{
    table{
        padding: 0 20px;
    }
}
.roles-basic-message-table{
    max-width: 500PX;
}
.menu-permissions{
    // margin-bottom: 20px;
    line-height: 40px;
}
.premission-checkbox{
    :global
    .el-checkbox{
        line-height: 40px;
    }
}
</style>
